import { Table, Text, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import type { OurFeesCompensationTableAdapterProps } from "modules/storyblok/adapters/OurFeesCompensationTable/OurFeesCompensationTable.d";
import type { ReactStoryblokComponent } from "types/storyblok";
import { storyblokEditable } from "@storyblok/react";
import { calculateAmount, useCompensationValue } from "./utils";
import tableStyles from "./styles";
import { STANDARD_FEE, STANDARD_COMPENSATION, LEGAL_FEE, LEGAL_COMPENSATION } from "./config";

const OurFeesCompensationTableDesktop = ({ blok }: ReactStoryblokComponent<OurFeesCompensationTableAdapterProps>) => {
  const {
    standardHeadingText,
    standardHeadingDescription,
    legalHeadingText,
    legalHeadingDescription,
    byAirlineHeadingText,
    ourFeeText,
    youWillRecieveText,
    compensationList,
  } = blok;

  const { getCompensationDAValue } = useCompensationValue();

  return (
    <Table sx={tableStyles} {...storyblokEditable(blok)}>
      <Thead>
        <Tr>
          <Th bg="white" />
          <Th colSpan={2} bg="primary.100" textTransform="none" textAlign="center" py={4}>
            <Text fontWeight="semibold">{standardHeadingText}</Text>
            <Text fontSize="sm" color="greyscale.600">
              {standardHeadingDescription}
            </Text>
          </Th>
          <Th colSpan={2} bg="primary.100" textTransform="none" textAlign="center" py={4}>
            <Text fontWeight="semibold">{legalHeadingText}</Text>
            <Text fontSize="sm" color="greyscale.600">
              {legalHeadingDescription}
            </Text>
          </Th>
        </Tr>
        <Tr bg="greyscale.200">
          <Th fontSize="md" color="primary.900" textTransform="none" textAlign="right">
            {byAirlineHeadingText}
          </Th>
          <Th fontSize="10px" color="greyscale.500" textAlign="right">
            {ourFeeText}
          </Th>
          <Th fontSize="10px" color="greyscale.500" textAlign="right">
            {youWillRecieveText}
          </Th>
          <Th fontSize="10px" color="greyscale.500" textAlign="right">
            {ourFeeText}
          </Th>
          <Th fontSize="10px" color="greyscale.500" textAlign="right">
            {youWillRecieveText}
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        {compensationList?.map((compensation) => (
          <Tr key={compensation._uid}>
            <Td>{getCompensationDAValue(calculateAmount(compensation.compensationAmount))}</Td>
            <Td>{getCompensationDAValue(calculateAmount(compensation.compensationAmount, STANDARD_FEE))}</Td>
            <Td fontWeight="semibold">
              {getCompensationDAValue(calculateAmount(compensation.compensationAmount, STANDARD_COMPENSATION))}
            </Td>
            <Td>{getCompensationDAValue(calculateAmount(compensation.compensationAmount, LEGAL_FEE))}</Td>
            <Td fontWeight="semibold">
              {getCompensationDAValue(calculateAmount(compensation.compensationAmount, LEGAL_COMPENSATION))}
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default OurFeesCompensationTableDesktop;
